import { graphql } from 'gql';

export const uerWorkOrderPriceItemChapterFilterGql = graphql(`
    query uerWorkOrderPriceItemChapterFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfNullableOfChapterEnumFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemChapterFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            rootObjectId: $rootObjectId
            objectId: $objectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceItemStatusFilterGql = graphql(`
    query uerWorkOrderPriceItemStatusFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemStatusFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceItemCodeFilterGql = graphql(`
    query uerWorkOrderPriceItemCodeFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemCodeFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value {
                    uerCodeId
                    uerCode
                    code
                    sortSMRPart
                    isUer
                    isRatio
                    isMtr
                }
            }
        }
    }
`);

export const uerWorkOrderPriceItemNameFilterGql = graphql(`
    query uerWorkOrderPriceItemNameFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfStringFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemNameFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceItemUnitFilterGql = graphql(`
    query uerWorkOrderPriceItemUnitFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfStringFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemUnitFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceItemWorkNameFilterGql = graphql(`
    query uerWorkOrderPriceItemWorkNameFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfStringFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemWorkNameFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceItemWorkInSumFilterGql = graphql(`
    query uerWorkOrderPriceItemWorkInSumFilter(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfNullableOfWorkInSumEnumFilterInput
        $rootObjectId: Long
        $objectId: Long
    ) {
        uerWorkOrderPriceItemWorkInSumFilter(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            rootObjectId: $rootObjectId
            objectId: $objectId
        ) {
            items {
                value
            }
        }
    }
`);
